import ajax from "@/utils/ajax.js";

export default {
  async getOrderNoticeAsync() {
    let response = await ajax.get("setting/GetOrderNoticeAsync");
    return response.result;
  },
  async getOptionsAsync() {
    let options = sessionStorage.getItem("options");
    if (options) {
      return JSON.parse(options);
    }
    return await this.getSettingsFromWeChatAsync();
  },
  async getSettingsFromWeChatAsync() {
    const response = await ajax.get("/setting/GetSettingsFromWeChatAsync");
    sessionStorage.setItem("options", JSON.stringify(response.result));
    return response.result;
  }
};
